const getContribuinteFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'codigo', label: 'Código', type: 'number' },
];

export default getContribuinteFilterFields;
